import moment from "moment/moment";
import React, { useState } from "react";
import { Modal, Row } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { editIcon, viewIcon } from "../../assets/img";
import CloseIcon from "@mui/icons-material/Close";
import { useSupportStatusMutation } from "../../redux/api/api";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";

const ActivePage = ({
  getSupportList,
  getResolveList,
  searchSupport,
  setSupportPage,
  supportCount,
  listSupport,
  paginationSupport,
  rowSupport,
  type,
}) => {
  const dispatch = useDispatch();
  const [btn, setBtn] = useState(false);
  const [modal, setModal] = useState(false);
  const [modals, setModals] = useState(false);
  const [description, setDescription] = useState("");
  const [resolve, setResolve] = useState("");
  const [resolveErr, setResolveErr] = useState(false);
  const [update, setUpdate] = useState({});
  const navigate = useNavigate();

  // RTK QUERY
  const [supportStatusApi] = useSupportStatusMutation();

  const handlePageChange = (selectedObject) => {
    setSupportPage(selectedObject.selected + 1);
  };

  const getView = (item, type) => {
    if (type == 2) {
      setUpdate(item);
      setResolve("");
      setResolveErr(false);
      setModals(true);
    } else {
      setDescription(item?.message);
      setModal(true);
    }
  };

  const onClose = () => {
    setModal(false);
    setDescription("");
    setModals(false);
    setUpdate({});
    setResolve("");
    setResolveErr(false);
  };

  const supportStatusHandler = () => {
    if (resolve?.length == 0) {
      setResolveErr(true);
    } else {
      dispatch(saveLoader(true));
      setBtn(true);
      let formdata = new FormData();
      formdata.append("reply_message", resolve);
      formdata.append("support_id", update?.id);
      formdata.append("type", type);
      supportStatusApi(formdata)
        .unwrap()
        .then((res) => {
          dispatch(saveLoader(false));
          setBtn(false);
          if (res?.status == "success") {
            onClose();
            getSupportList("", "");
            getResolveList("", "");
          }
        })
        .catch((err) => {
          dispatch(saveLoader(false));
          setBtn(false);
          console.log("err", err);
        });
    }
  };

  return (
    <div>
      {" "}
      <Row md={12} sm={12} lg={12}>
        <div className="col-md-6 mt-5">
          <label className="table-labels f1">
            Total Count : {paginationSupport?.total}
          </label>
        </div>
      </Row>
      <div className="d-flex ac-jb ">
        <div className="col-md-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) => getSupportList(searchSupport, e.target.value)}
            value={rowSupport}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>

        <div className="mb-2">
          <input
            className="form-control bg-white"
            placeholder="Eg: Support Id"
            style={{ width: "300px" }}
            onChange={(e) => getSupportList(e.target.value, rowSupport)}
            value={searchSupport}
          />
        </div>
      </div>
      <div className="table-custom-design overflow-scroll">
        <table>
          <thead className="single-book-table">
            <tr className="text-capitalize text-nowrap">
              <th>S.NO</th>
              <th>Support Id</th>
              <th>User Name</th>
              <th>E-mail</th>
              <th>Mobile Number</th>
              <th>Descreption</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {listSupport?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    {(paginationSupport?.current_page - 1) * rowSupport +
                      ind +
                      1}
                  </td>
                  {/* moment(item?.created_at).format("DD-MM-YYYY") */}
                  <td>{item?.support_id}</td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() =>
                        navigate("/user", {
                          state: { data: item },
                        })
                      }
                    >
                      {item?.name}
                    </button>
                  </td>
                  <td>{item?.email}</td>
                  <td>{item?.mobile}</td>
                  <td>{item?.message}</td>
                  <td>
                    <div className="d-flex flex-column">
                      <button
                        className="cust-btn"
                        onClick={() => getView(item, 1)}
                      >
                        <img src={viewIcon} className="edit-btn" />
                      </button>
                      <button
                        className={`${"btn-success"} px-2 py-1 rounded-1 border-0 text-white mt-2`}
                        onClick={() => getView(item, 2)}
                      >
                        Active
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={supportCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
      <Modal
        show={modal}
        onHide={() => {
          onClose();
        }}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-3">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                Support View
              </label>
              <button className="cust-btn" onClick={() => onClose()}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row className="p-4">
            <div className="col-md-12">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                Description
              </label>
              <div>
                <div className="form-group">
                  <textarea
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    value={description}
                    readOnly
                    rows={4}
                  />
                </div>
              </div>
            </div>
          </Row>
          <div className="text-center mb-3 mt-3">
            <button
              className={`submit-btn f2 mx-4`}
              onClick={() => {
                onClose();
              }}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        show={modals}
        onHide={() => {
          onClose();
        }}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-3">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                Resolve Support
              </label>
              <button className="cust-btn" onClick={() => onClose()}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row className="p-4">
            <div className="col-md-12">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                Reply Message
              </label>
              <div>
                <div className="form-group">
                  <textarea
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setResolve(e.target.value)}
                    value={resolve}
                    rows={4}
                  />
                </div>
                {resolve?.length == 0 && resolveErr && (
                  <p className="err">Enter Reply Message</p>
                )}
              </div>
            </div>
          </Row>
          <div className="text-center mb-3 mt-3">
            <button
              className={`submit-btn f2 mx-4 ${btn ? "opacity-50" : ""}`}
              onClick={() => {
                supportStatusHandler();
              }}
              disabled={btn}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ActivePage;
